import { MagnifyingGlass } from '@phosphor-icons/react';

import { Button } from 'core/components';

export const PopupIndicator = () => {
  return (
    <Button
      icon={<MagnifyingGlass />}
      sx={{
        alignSelf: 'center',
        marginInlineStart: 'calc(var(--_Input-paddingBlock) / 2)',
        marginInlineEnd: 'calc(var(--Input-decoratorChildOffset)* -1)',
        display: 'block',
        fontSize: '10px',
      }}
    />
  );
};
